"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const contexts_1 = require("@App/contexts");
const CellInput_1 = __importDefault(require("@Components/ViewWork/Table/ValidationCells/CellInput"));
require("./index.scss");
const CellDisplayList_1 = __importDefault(require("@Components/ViewWork/Table/ValidationCells/CellDisplayList"));
const contact_1 = require("@App/api/routes/rightsholder/contact");
const ContactDetailsBlock_1 = __importDefault(require("@Components/ViewWork/PublisherCard/ContactDetailsBlock"));
const GroupedTable_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/GroupedPublishersTable/GroupedTable"));
const common_1 = require("@Const/common");
const GroupedPublishersFooter_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/GroupedPublishersTable/GroupedPublishersFooter"));
const publishers_table_schema_1 = require("@Entities/schemas/wizardFlow/publishers-table-schema");
const lodash_1 = require("lodash");
const MlcTooltip_1 = __importDefault(require("@Components/MlcTooltip"));
const table_cell_sanitizer_1 = require("@App/helpers/table-cell-sanitizer");
const GroupedPublishersTable = (0, react_1.forwardRef)((props, ref) => {
    const { allowShareEditing, onValidation } = props;
    const { rightsholderStore, overclaimViewStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [groupedPublisherInfo, setGroupedPublisherInfo] = (0, react_1.useState)();
    const [shareCount, setShareCount] = (0, react_1.useState)(0);
    const initialWork = (0, react_1.useMemo)(() => (0, lodash_1.cloneDeep)(overclaimViewStore.overclaimViewItem), [overclaimViewStore.overclaimViewItem]);
    const amendShareToZeroTooltipId = 'overclaim-amend-share-zero-error';
    const setupPublicContacts = (ipids) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (ipids === null || ipids === void 0 ? void 0 : ipids.length) {
            const response = yield (0, contact_1.getPublicContacts)(ipids);
            return (_a = response.data) !== null && _a !== void 0 ? _a : undefined;
        }
        return undefined;
    });
    (0, react_1.useEffect)(() => {
        if (!allowShareEditing) {
            overclaimViewStore.setOverclaimViewItem(initialWork);
        }
        publisherTableInfo().then((r) => setGroupedPublisherInfo(r));
    }, [allowShareEditing]);
    const updateGroupedPublisherShares = (publisherGroup, shareDifference) => {
        if (groupedPublisherInfo && publisherGroup !== -1) {
            setGroupedPublisherInfo((prevGroupedPublisherInfo) => {
                var _a, _b;
                if (!prevGroupedPublisherInfo) {
                    return;
                }
                const newGroupedPublishers = [...prevGroupedPublisherInfo];
                const groupedValue = (_b = (_a = newGroupedPublishers[publisherGroup]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.groupedValue;
                if (typeof groupedValue === 'number') {
                    newGroupedPublishers[publisherGroup][0].groupedValue = groupedValue - shareDifference;
                }
                return newGroupedPublishers;
            });
        }
    };
    const updateShare = (model, newValue, adminModel) => {
        var _a;
        let entityToBeUpdated;
        const modelIpid = adminModel ? adminModel.ipId : model.ipId;
        (_a = overclaimViewStore.overclaimViewItem) === null || _a === void 0 ? void 0 : _a.originalPublishers.forEach((publisher) => {
            if (publisher.ipId === model.ipId) {
                if (!adminModel) {
                    // if not an admin publisher we always update the original publisher
                    entityToBeUpdated = publisher;
                }
                else {
                    // if an admin publisher we update the admin publisher, but both the admin and op must match
                    const foundAdmin = publisher.administratorPublishers.find((admin) => admin.ipId === modelIpid);
                    if (foundAdmin) {
                        entityToBeUpdated = foundAdmin;
                    }
                }
            }
        });
        if (groupedPublisherInfo && entityToBeUpdated) {
            if (entityToBeUpdated) {
                const shareDifference = entityToBeUpdated.publisherShare != null
                    ? parseFloat((Number(entityToBeUpdated.publisherShare) - newValue).toFixed(2))
                    : 0;
                entityToBeUpdated.publisherShare = newValue;
                const publisherGroup = groupedPublisherInfo.findIndex((group) => group.some((publisher) => publisher.rows[0].name === String(modelIpid)));
                updateGroupedPublisherShares(publisherGroup, shareDifference);
                setShareCount((prevShareCount) => prevShareCount - shareDifference);
            }
        }
    };
    const publisherRows = (rows, contacts) => rows.map((model, index) => {
        var _a, _b, _c;
        return ({
            name: `${model.ipId}`,
            headerRow: { row: [] },
            removeCellIdentifier: (_a = model.ipId) !== null && _a !== void 0 ? _a : '',
            removable: true,
            cells: [
                react_1.default.createElement(CellInput_1.default, { defaultValue: model.publisherName, readOnly: true, name: `rows.publisherRows[${index}].publisherName`, key: `rows.publisherRows[${index}].publisherName`, type: 'text' }),
                react_1.default.createElement(CellInput_1.default, { name: `rows.publisherRows[${index}].publisherPNumber`, key: `rows.publisherRows[${index}].publisherPNumber`, defaultValue: (_b = model.hfaPublisherNumber) !== null && _b !== void 0 ? _b : '', readOnly: true, type: 'text' }),
                react_1.default.createElement(CellInput_1.default, { name: `rows.publisherRows[${index}].publisherIPINumber`, key: `rows.publisherRows[${index}].publisherIPINumber`, defaultValue: (_c = model.ipiNumber) !== null && _c !== void 0 ? _c : '', readOnly: true, type: 'number' }),
                react_1.default.createElement(CellDisplayList_1.default, { key: `rows.publisherRows[${index}].writersList`, items: model.writers }),
                react_1.default.createElement(CellInput_1.default, { name: `rows.publisherRows[${index}].publisherShare`, key: `rows.publisherRows[${index}].publisherShare`, defaultValue: model.publisherShare, min: 0, max: 100.06, readOnly: !allowShareEditing ||
                        !(Number(model.topMemberIpId) === rightsholderStore.currentRightsholderId), tooltipId: amendShareToZeroTooltipId, onValueChanged: (value) => {
                        if (model.administratorPublishers.length === 0) {
                            updateShare(model, value);
                        }
                    }, type: 'number' }),
                react_1.default.createElement("div", { key: `rows.publisherRows[${index}].contactInformation`, className: 'contact-information' }, (() => {
                    var _a;
                    const foundContact = (_a = contacts === null || contacts === void 0 ? void 0 : contacts.data) === null || _a === void 0 ? void 0 : _a.find((contact) => (contact === null || contact === void 0 ? void 0 : contact.ipId) === model.topMemberIpId);
                    return foundContact ? react_1.default.createElement(ContactDetailsBlock_1.default, { contact: foundContact }) : null;
                })()),
            ],
        });
    });
    const adminTableRows = (rows, contacts) => rows.map(({ publisherModel, adminModel }, index) => {
        var _a, _b, _c;
        return ({
            name: `${adminModel.ipId}`,
            headerRow: { row: [] },
            removeCellIdentifier: (_a = adminModel.ipId) !== null && _a !== void 0 ? _a : '',
            removable: true,
            cells: [
                react_1.default.createElement(CellInput_1.default, { defaultValue: adminModel.publisherName, readOnly: true, name: `rows.administratorRows[${index}].administratorName`, key: `rows.administratorRows[${index}].administratorName`, type: 'text' }),
                react_1.default.createElement(CellInput_1.default, { name: `rows.administratorRows[${index}].administratorPNumber`, key: `rows.administratorRows[${index}].administratorPNumber`, defaultValue: adminModel.hfaPublisherNumber, readOnly: true, type: 'text' }),
                react_1.default.createElement(CellInput_1.default, { name: `rows.administratorRows[${index}].administratorIPI`, key: `rows.administratorRows[${index}].administratorIPI`, defaultValue: adminModel.ipiNumber, readOnly: true, type: 'number' }),
                react_1.default.createElement(CellDisplayList_1.default, { key: `rows.administratorRows[${index}].writersList`, items: publisherModel.writers }),
                react_1.default.createElement(CellInput_1.default, { name: `rows.administratorRows[${index}].administratorShare`, key: `rows.administratorRows[${index}].administratorShare`, defaultValue: (_b = adminModel.publisherShare) !== null && _b !== void 0 ? _b : '', min: 0, max: 100.06, readOnly: !allowShareEditing ||
                        !(Number(adminModel.topMemberIpId) === rightsholderStore.currentRightsholderId), onValueChanged: (value) => {
                        updateShare(publisherModel, value, adminModel);
                    }, type: 'number' }),
                react_1.default.createElement("div", { key: `rows.administratorRows[${index}].contactInformation`, className: 'contact-information' }, (() => {
                    var _a;
                    const foundContact = (_a = contacts === null || contacts === void 0 ? void 0 : contacts.data) === null || _a === void 0 ? void 0 : _a.find((contact) => (contact === null || contact === void 0 ? void 0 : contact.ipId) === adminModel.topMemberIpId);
                    return foundContact ? react_1.default.createElement(ContactDetailsBlock_1.default, { contact: foundContact }) : null;
                })()),
            ],
            subTables: [
                {
                    headerRow: {
                        row: [
                            { text: 'Name' },
                            { text: 'P Number' },
                            { text: 'IPI' },
                            { text: 'Represented Writers' },
                        ],
                    },
                    rows: [
                        {
                            removeCellIdentifier: (_c = publisherModel.ipId) !== null && _c !== void 0 ? _c : '',
                            removable: false,
                            cells: [
                                (0, table_cell_sanitizer_1.tableCellSanitizer)(publisherModel.publisherName),
                                (0, table_cell_sanitizer_1.tableCellSanitizer)(publisherModel.hfaPublisherNumber),
                                (0, table_cell_sanitizer_1.tableCellSanitizer)(publisherModel.ipiNumber),
                                react_1.default.createElement(CellDisplayList_1.default, { key: publisherModel.ipId, items: publisherModel.writers }),
                            ],
                        },
                    ],
                },
            ],
        });
    });
    const publisherTableInfo = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const groupedPublishers = (_a = overclaimViewStore.overclaimViewItem) === null || _a === void 0 ? void 0 : _a.originalPublishers.reduce((prev, curr) => {
            ;
            (prev[String(curr.topMemberName)] = prev[String(curr.topMemberName)] || []).push(curr);
            return prev;
        }, {});
        const result = [];
        let totalShares = 0;
        for (const topMember of Object.keys(groupedPublishers)) {
            const admins = [];
            const adminIpids = [];
            const originalIpids = [];
            const nonAdminsPubs = [];
            let groupedShare = 0;
            groupedPublishers[topMember].forEach((model) => {
                const hasAdmin = model.administratorPublishers.length > 0;
                if (hasAdmin) {
                    model.administratorPublishers.forEach((admin) => {
                        admins.push({ publisherModel: model, adminModel: admin });
                        adminIpids.push(admin.topMemberIpId);
                        groupedShare += Number(admin.publisherShare);
                    });
                }
                else {
                    nonAdminsPubs.push(model);
                    originalIpids.push(model.topMemberIpId);
                    groupedShare += Number(model.publisherShare);
                }
            });
            const ipids = [...adminIpids, ...originalIpids].filter((ipid) => !!ipid);
            const contacts = yield setupPublicContacts(ipids);
            const adminRows = adminTableRows(admins, contacts);
            const nonAdminRows = publisherRows(nonAdminsPubs, contacts);
            const tableRowToGroupedTableInfo = (row) => ({
                groupedBy: groupedPublishers[topMember][0].topMemberName,
                groupedValue: groupedShare,
                headerRow: {
                    row: [
                        { text: 'Name' },
                        { text: 'P Number' },
                        { text: 'IPI' },
                        { text: 'Represented Writers' },
                        { text: 'Collection Share' },
                        { text: 'Contact Details' },
                    ],
                },
                rows: [row],
            });
            const adminRowsMapped = adminRows.map(tableRowToGroupedTableInfo);
            const nonAdminRowsMapped = nonAdminRows.map(tableRowToGroupedTableInfo);
            totalShares += groupedShare;
            result.push([...adminRowsMapped, ...nonAdminRowsMapped]);
        }
        setShareCount(totalShares);
        return result;
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MlcTooltip_1.default, { style: { maxWidth: '25rem' }, className: 'tooltip', id: amendShareToZeroTooltipId, variant: 'warning', place: 'top' },
            react_1.default.createElement("span", null,
                "If you are trying to enter zero",
                react_1.default.createElement("strong", null, " (0) "),
                "as your share amount, please return to the previous screen and select the",
                react_1.default.createElement("strong", null, " Relinquish Shares "),
                "button to relinquish all of your shares on this work.")), groupedPublisherInfo === null || groupedPublisherInfo === void 0 ? void 0 :
        groupedPublisherInfo.map((publisher, index) => (react_1.default.createElement(GroupedTable_1.default, { key: index, tableInfo: publisher, icon: common_1.ICONS.account, validationSchema: overclaimViewStore.overclaimViewItem &&
                (0, publishers_table_schema_1.generatePublishersTableSchema)(overclaimViewStore.overclaimViewItem), rowsAreValid: (isValid) => onValidation(isValid), ref: ref }))),
        react_1.default.createElement(GroupedPublishersFooter_1.default, { totalShares: shareCount })));
});
GroupedPublishersTable.displayName = 'GroupedPublishersTable';
exports.default = (0, mobx_react_1.observer)(GroupedPublishersTable);
